import { render, staticRenderFns } from "./RejectValidationModal.vue?vue&type=template&id=189b3b22"
import script from "./RejectValidationModal.vue?vue&type=script&lang=js"
export * from "./RejectValidationModal.vue?vue&type=script&lang=js"
import style0 from "./RejectValidationModal.vue?vue&type=style&index=0&id=189b3b22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports